import React, { Component } from 'react'
import Loading from './Loading'
import _ from 'lodash'
import Container from './Container'

class Callback extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: false,
      authSuccess: false,
      error: false
    }
  }
  async handleAuthentication (auth, nextState, replace) {
    if (/access_token|id_token|error/.test(nextState.location.hash)) {
      let authSuccess =  await auth.handleAuthentication();
      console.log('authSuccess',authSuccess)
      if(authSuccess){
        this.setState({authSuccess})
        return
      }
    }
      this.setState({error: true})
  }
  render() {
    const auth = this.props.route.auth
    if(this.state.error || _.isUndefined(this.state.authSuccess)){
      return (<h1 className='offline'>Error on login, invalid user or domain doesn't allowed</h1>)
    } else if(!this.state.authSuccess){
      this.handleAuthentication(auth, this.props);
      return (
        <Loading/>
      )
    } else if(this.state.authSuccess){
      // return (<h1 className='online'> Welcome you were logged in!! <IndexLink activeClassName='ms-active' to="/home">Continue -></IndexLink></h1>)
      return (
        <Container {...this.props} msg = {'Welcome you were logged in!!'}/>
      )
    }
  }
}

export default Callback;


// WEBPACK FOOTER //
// ./src/components/Callback.js